<template>
  <tr class="tariff_item" >
    <td :data-label="translate('tariffication.tariff_id')"
        class="w50"
        v-if="$store.getters.getPermissions.permissionGod === true"
    >
      {{ tariff_device.id }}
    </td>
    <td :data-label="translate('tariffication.status')" class="w50">
      <span v-if="tariff_device.status" class="mdi mdi-currency-rub problem_device tariffication" />
    </td>
    <td :data-label="translate('tariffication.device_status')" class="w5per">
      <span v-if="tariff_device.device_uptime_status" class="mdi mdi-access-point online" />
      <span v-else class="mdi mdi-access-point-off offline" />
    </td>
    <td
        :data-label="translate('tariffication.auto_block_status')"
        class="w5per"
        v-if="$store.getters.getPermissions.permissionGod === true"
    >
      {{ tariff_device.auto_block === true? "Да" : tariff_device.auto_block === false ? "Нет" : "" }}
    </td>
    <td
        :data-label="translate('tariffication.device')"
        @click.stop=""
    >
      <router-link :to="{path: '/device/' + tariff_device.fid}">
        {{ tariff_device.fid }}
      </router-link>
      <p>
        {{ tariff_device.device_name }}
      </p>
    </td>
    <td :data-label="translate('tariffication.order')">
      {{ tariff_device.order }}
    </td>
    <td :data-label="translate('tariffication.service')">
      {{ tariff_device.client_service_id }}
    </td>
    <td
        :data-label="translate('tariffication.client_name')"
        @click.stop=""
        v-if="$store.getters.getPermissions.permissionGod === true"
    >
      <router-link :to="{path: '/client/' + tariff_device.client_id}">
        {{ tariff_device.client_name }}
      </router-link>
    </td>
    <td
        :data-label="translate('tariffication.tariff_name')"
        @click.stop=""
    >
      <router-link
          v-if="tariff_device.tariff_id"
          :to="{path: '/tariff/' + tariff_device.tariff_id}"
      >
        {{ tariff_device.tariff_name }}
      </router-link>
      <p v-else>
        {{ tariff_device.tariff_name }}
      </p>
    </td>
    <td
        :data-label="translate('tariffication.username')"
        @click.stop=""
        v-if="$store.getters.getPermissions.permissionGod === true"
    >
      <router-link :to="{path: '/user/' + tariff_device.username_start}">
        {{ tariff_device.username_start }}
      </router-link>
      <template v-if="tariff_device.date_end">
        /
        <router-link :to="{path: '/user/' + tariff_device.username_end}">
          {{ tariff_device.username_end }}
        </router-link>
      </template>
    </td>
    <td class="w7per" :data-label="translate('tariffication.date_start')">
      {{ tariff_device.date_start }}
    </td>
    <td class="w7per" :data-label="translate('tariffication.date_end')">
      {{ tariff_device.date_end }}
    </td>
  </tr>
</template>

<script>

export default {
  name: 'TariffedDevicesItem',
  components: {},
  props: ['tariff_device'],

}
</script>

<style lang='scss' scoped>
.tariff_item{
  font-size: 12px;
  cursor: pointer;
  td{
    vertical-align: middle;
  }
  p{
    margin-bottom: 0;
    font-size: 12px;
  }
  span.mdi{
    font-size: 14px;
    &.online{
      color: #15ab00;
    }
    &.tariffication{
      color: #3f93d3;
    }
  }
  &:hover{
    background-color: #eaeaea;
  }

}
</style>
